// src/hooks/useSyncOperatingAoiSelection.js
//
// Auto-clears the LayerPanel's selected user AOI whenever the operator
// switches operating AOIs. Pairs with useSyncOperatingAoiImagery and
// useSyncOperatingAoiCoverage — same trigger (activeOperatingAoiId
// change), same lifecycle.
//
// Why: when the workbench changes, a stale "current AOI" left over from
// the previous workbench is misleading — its geometry may not even
// intersect the new operating AOI. Clearing makes the new workbench
// land in a clean "operating AOI set, no user focus yet" state.
//
// First-run guard: a ref-based "skip first effect" pattern prevents
// clearing on mount, when activeOperatingAoiId is just settling into
// its initial value (which is null today, but defensive). Subsequent
// changes — including transitioning to null from a set value — fire
// the clear.
//
// No persistence story is needed because useOperatingAoiContext doesn't
// persist; every session starts with activeOperatingAoiId=null and an
// empty selectedAoiId.

import { useEffect, useRef } from "react";
import { useOperatingAoiContext } from "../stores/useOperatingAoiContext";
import { useAoiStore } from "../stores/useAoiStore";

export function useSyncOperatingAoiSelection() {
  const activeOperatingAoiId = useOperatingAoiContext(
    (s) => s.activeOperatingAoiId
  );
  const isFirstRunRef = useRef(true);

  useEffect(() => {
    if (isFirstRunRef.current) {
      isFirstRunRef.current = false;
      return;
    }
    useAoiStore.getState().setSelectedAoiForMap(null);
  }, [activeOperatingAoiId]);
}
